import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Button, Text } from 'view/atoms';
import * as S from '../../ProvideAccessModal.styles';

type Props = {
  email?: string;
  onOk: () => void;
};

export const ProvideAccessNotice = ({ email, onOk }: Props) => {
  const { t } = useTranslation();

  return (
    <S.ModalNoticeWrapper>
      <S.HeaderWrapper style={{ textAlign: 'center' }}>
        <Text kind='h2'>{t('profile.accessModal.sentTitle')}</Text>
        <Text kind='body'>
          <Trans
            t={t}
            i18nKey='profile.accessModal.sentDescription'
            values={{ email }}
          />
        </Text>
      </S.HeaderWrapper>

      <Button kind='primary' onClick={onOk}>
        <Text kind='button'>{t('other.ok')}</Text>
      </Button>
    </S.ModalNoticeWrapper>
  );
};
